export default __webpack_public_path__ + "static/media/pic03.fff9d327.jpg";